import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DocumentUpload, DocumentList, DocStatusSummary, docStatus } from "@/pages/employer/Documents";
import { PageLoading, PageHeader } from "@/components/shared";
import api from "@/lib/api";

export default function WorkerDocuments() {
  const { t } = useTranslation();
  const [docs, setDocs] = useState(null);
  const [status, setStatus] = useState("all");
  const load = () => api.get("/worker/documents").then((r) => setDocs(r.data.documents));
  useEffect(() => { load(); }, []);
  const filtered = (docs || []).filter((d) => status === "all" || docStatus(d) === status);
  return (
    <div data-testid="worker-documents">
      <PageHeader title={t("worker.myDocuments")} subtitle={t("worker.uploadRequested")} action={<DocumentUpload worker onDone={load} />} />
      {docs && docs.length > 0 && <DocStatusSummary docs={docs} active={status} onSelect={setStatus} />}
      {docs === null ? <PageLoading /> : <DocumentList docs={filtered} onChange={load} showEmployee={false} canDelete={false} />}
    </div>
  );
}
